import { async } from 'rxjs/internal/scheduler/async';
import { ListGoodTranferUnloadViewModel } from '../models/getListGoodTranferUnload.model';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ResponseModel } from "../models/response.model";
import { BaseModel } from "../models/base.model";
import { GeneralService } from "./general.service";
import { HttpParams } from "@angular/common/http";
import { PersistenceService } from "angular-persistence";
import { environment } from "../../environments/environment";
import { ListUpdateStatusViewModel, ReceiverInfo } from "../view-model/index";

import * as moment from "moment";
import { AssignShipmentToTPL } from "../models/assignShipmentToTPL.model";
import { UpdateScheduleModel } from "../models/updateSchedule.model";
import { AssignShipmentWarehousing } from "../models/assignShipmentWarehousing.model";
import { IdViewModel } from "../view-model/id.viewModel";
import { IdModel } from "../view-model/id.model";
import { Shipment, LadingSchesule, Boxes, LastShipmentContractModel, filterShipmentModel } from "../models";
import { ListGoods } from "../models/listGoods.model";
import { MessageService } from "primeng/components/common/messageservice";
import { ShipmentFilterViewModel } from "../models/shipmentFilterViewModel";
import { UpdateViewModelShipment } from "../models/abstract/updateViewModelShipment.interface";
import { ShipmentTracking } from "../models/abstract/shipmentTracking.interface";
import { SelectItem } from "../../../node_modules/primeng/primeng";
import { UpdateShipmentDeliveryComplete } from "../models/abstract/updateShipmentDeliveryComplete.interface";
import { IncidentsFilter } from "../models/incidentsFilter.model";
import { HandleIncidents } from "../models/handleIncidents.model";
import { AddCompensation } from "../models/addCompensation.model";
import { UpdateStatusCurrentEmp } from "../models/updateStatusCurrentEmp.models";
import { GetListWarehousingFilter } from "../models/getListWarehousingFilter.model";
import { DeliveryAndhubRouting } from "../view-model/deliveryAndHubRouting.viewModel";
import { RequestShipmentFilterViewModel } from "../models/abstract/requestShipmentFilterViewModel.interface";
import { ResponseOfRequestShipment } from "../models/abstract/responseOfRequestShipment.interface";
import { ListShipmentsFilter } from "../models/getListShipmentsFlter.model";
import { ListBoxCodeViewModel } from "../models/listBoxCode.viewModel";
import { UpdateShipment } from "../models/updateShipment.model";
import { listGoodTranferUnload } from '../models/listGoodTranferUnload.model';
import { GetListUnloadInventoryFilterViewModel } from '../models/getListUnloadInventoryFilter.model';
import { WarehouseDeliveryFailedFilter } from '../models/warehouseDeliveryFailedFilter.model';
import { SenderInfo } from '../view-model/senderInfor.viewModel';
import { ShipmentContact } from '../models/shipmentContact.model';
import { ReportDeliveryEmployeeExport } from '../models/reportDeliveryEmployeeExport';
import { data } from 'jquery';
import { ReportDeliveryEmployee } from '../models/reportDeliveryEmployee';
import { WareHouseFilterModel } from '../models/wareHouseFilter.model';
import { ShipmentListGoods } from '../models/shipmentListGoods.model';
import { ListShipmentDeliveryPlaceFilter } from '../models/listShipmentDeliveryPlaceFilter.model';
import { ListPriceByShipmentId } from '../models/listPriceByShipmentId.model';
import { AssignDeliveryModel } from '../models/assignDelivery.model';
import { PrintQrCodeVnPayModel } from '../models/printQrCodeVnPay.model';
import { CheckValidSaveWarehouse } from '../models/CheckValidSaveWareHouse.model';
import { IssueTransferByProcModel } from '../models/issueTransferProc.model';
import { QrPaymentShipmentModel } from '../models/qrPaymentShipment.model';

@Injectable()
export class ShipmentService extends GeneralService {
  constructor(
    protected messageService: MessageService,
    protected httpClient: HttpClient,
    protected persistenceService: PersistenceService
  ) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "shipment");
  }

  async getListIncidents(model: IncidentsFilter) {
    let params = new HttpParams();
    params = params.append("empId", model.empId);
    params = params.append("shipmentNumber", model.shipmentNumber);
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("pageSize", model.pageSize);
    params = params.append("pageNum", model.pageNum);
    params = params.append("cols", model.cols);

    let res = await this.getCustomApi("GetListIncidents", params).toPromise();
    return res;
  }

  postByTypeByProc(model: RequestShipmentFilterViewModel): Observable<ResponseOfRequestShipment> {
    if (model.isEnabled == null) {
      model.isEnabled = true; // mặc định isEnabled = true
    }
    if (model.isSortDescending == null) {
      model.isSortDescending = true; // mặc định sắp xếp id giảm dần
    }
    return super.postCustomApi("postByTypeByProc", model) as Observable<ResponseOfRequestShipment>;
  }

  async postByTypeByProcAsync(model: RequestShipmentFilterViewModel): Promise<ResponseOfRequestShipment> {
    let res = await this.postByTypeByProc(model).toPromise();
    return res;
  }

  async getIncidentsById(incidentsId: any, cols: string = null) {
    let params = new HttpParams();
    params = params.append("incidentsId", incidentsId);
    params = params.append("cols", cols);

    let res = await this.getCustomApi("getIncidentsById", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  getByListCode(listCode: string[]) {
    return super.postCustomUrlApi(environment.apiPostUrl, "getByListCode", listCode);
  }

  async getByListCodeAsync(listCode: string[]): Promise<Shipment[]> {
    const res = await this.getByListCode(listCode).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getByType(
    type: string,
    arrCols: string[] = [],
    fromDate?: any,
    toDate?: any,
    pageSize?: number,
    pageNumber?: number
  ) {
    let params = new HttpParams();
    params = params.append("type", type);
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging(
      "getByType",
      arrCols,
      params,
      pageSize,
      pageNumber
    );
  }

  async getByTypeAsync(
    type: string,
    arrCols?: string[],
    fromDate?: any,
    toDate?: any,
    pageSize?: number,
    pageNumber?: number
  ): Promise<Shipment[]> {
    const res = await this.getByType(
      type,
      arrCols,
      fromDate,
      toDate,
      pageSize,
      pageNumber
    ).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  postByType(
    filterViewModel?: ShipmentFilterViewModel,
  ) {
    return super.postCustomApiPaging(
      "postByType",
      filterViewModel,
    );
  }

  async postByTypeAsync(
    filterViewModel?: ShipmentFilterViewModel
  ): Promise<any> {
    const res = await this.postByType(
      filterViewModel
    ).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipment(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipment", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  async getListShipmentBoxToCheck(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentBoxToCheck", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  async getListShipmentWaitAssignPickup(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentWaitAssignPickup", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async GetListShipmentsToEditInfo(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentsToEditInfo", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async EditShipmentInfo(updateShipmentViewModel?: UpdateShipment): Promise<ResponseModel> {
    const res = await super.postCustomApi("EditShipmentInfo", updateShipmentViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  async getListShipments(filterViewModel?: ListShipmentsFilter): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipments", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getReportListShipment(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetReportListShipment", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getListShipmentKeepingByUserId(userId: number, recovery?: any, isPickup?: any, dateFrom?: any, dateTo?: any, cols?: string[], pageSize?: number, pageNumber?: number) {
    let params = new HttpParams();
    params = params.append("userId", userId + "");
    params = params.append("recovery", recovery);
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("isPickup", isPickup);
    return super.getCustomApiPaging("GetListShipmentKeeping", cols, params, pageSize, pageNumber);
  }

  async getListShipmentKeepingByUserIdAsync(userId: number, recovery?: any, isPickup?: any, dateFrom?: any, dateTo?: any, cols?: string[], pageSize?: number, pageNumber?: number): Promise<Shipment[]> {
    const res = await this.getListShipmentKeepingByUserId(userId, recovery, isPickup, dateFrom, dateTo, cols, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  async getListWarehousing(model: GetListWarehousingFilter): Promise<Shipment[]> {
    let params = new HttpParams();
    params = params.append("warehousingType", model.warehousingType);
    params = params.append("userId", model.userId);
    params = params.append("hubId", model.hubId);
    params = params.append("serviceId", model.serviceId);
    params = params.append("isPrioritize", model.isPrioritize);
    params = params.append("isAllShipment", model.isAllShipment);
    params = params.append("isIncidents", model.isIncidents);
    params = params.append("isNullHubRouting", model.isNullHubRouting);
    if (model.listGoodsList) params = params.append("listGoodsList", model.listGoodsList.join(","));
    params = params.append("typeWarehousing", model.typeWarehousing);
    params = params.append("pageNumber", model.pageNumber);
    params = params.append("pageSize", model.pageSize);
    params = params.append("toHubId", model.toHubId);
    params = params.append("toUserId", model.toUserId);
    params = params.append("senderId", model.senderId);
    params = params.append("dateFrom", model.orderDateFrom);
    params = params.append("dateTo", model.orderDateTo);

    let res = await super.getCustomApi("GetListWarehousing", params).toPromise();

    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  //#region Nhập kho hàng mới
  async wareHousingShipment(model: GetListWarehousingFilter): Promise<Shipment[]> {
    let res = await super.postCustomApi("WareHousingShipment", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async receiptWarehousingShipment(model: AssignShipmentWarehousing): Promise<any> {
    let res = await super.postCustomApi("ReceiptWarehousingShipment", model).toPromise();
    return res;
  }

  async listReceiptWarehousingShipment(model: AssignShipmentWarehousing[]): Promise<any> {
    let res = await super.postCustomApi("ListReceiptWarehousingShipment", model).toPromise();
    return res;
  }

  async listReceiptWarehousingShipmentNew(model: AssignShipmentWarehousing[]): Promise<any> {
    let res = await super.postCustomApi("ListReceiptWarehousingShipmentNew", model).toPromise();
    return res;
  }
  //#endregion

  //#region Tạo phiếu chuyển hàng
  async getListShipmentTranferLong(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentTranferLong", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipmentTranferLongNew(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentTranferLongNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipmentTranfer(model?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentTranfer", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipmentTranferNew(model?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentTranferNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getShipmentByListGoodsId(listGoodsId?: any, pageNumber?: any, pageSize?: any, listShipmentStatusIds?: any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("listGoodsId", listGoodsId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    if (listShipmentStatusIds)
      params = params.append("listShipmentStatusIds", listShipmentStatusIds);
    let res = await super.getCustomApi("GetShipmentByListGoodsId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getShipmentByListGoodsIdNew(listGoodsId?: any, pageNumber?: any, pageSize?: any, listShipmentStatusIds?: any, isGoodsMissing?: any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("listGoodsId", listGoodsId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    params = params.append("isGoodsMissing", isGoodsMissing);
    if (listShipmentStatusIds)
      params = params.append("listShipmentStatusIds", listShipmentStatusIds);
    let res = await super.getCustomApi("GetShipmentByListGoodsIdNew", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getShipmentUnloadReport(model: any): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetShipmentUnloadReport", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getShipmentBoxPrintByListGoodsId(listGoodsId?: any): Promise<Shipment[]> {
    let params = new HttpParams();
    params = params.append("listGoodsId", listGoodsId);
    let res = await super.getCustomApi("GetShipmentBoxPrintByListGoodsId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentDeliveryAwaitReceipt(model?: WarehouseDeliveryFailedFilter): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentDeliveryAwaitReceipt", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  // async receiptWarehousingShipment(model: AssignShipmentWarehousing): Promise<any> {
  //   let res = await super.postCustomApi("ReceiptWarehousingShipment", model).toPromise();
  //   return res.isSuccess;
  // }
  //#endregion

  async getAsync(id: any, arrCols?: string[]): Promise<any> {
    const res = await this.get(id, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }
  async GetTotalPaymentWhenDelivered(id: any): Promise<any> {
    let params = new HttpParams();
    params = params.append("id", id);
    const res = await this.getCustomApi("GetTotalPaymentWhenDelivered", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data;
    return data;

  }

  getByStatusCurrentEmp(
    statusId: any,
    arrCols: string[] = [],
    pageSize: number = undefined,
    pageNumber: number = undefined
  ) {
    let params = new HttpParams();
    params = params.append("statusId", statusId);

    return super.getCustomApiPaging(
      "getByStatusCurrentEmp",
      arrCols,
      params,
      pageSize,
      pageNumber
    );
  }

  async getDeliveryAndHubRoutingAsync(listGoodsId: any): Promise<DeliveryAndhubRouting[]> {
    let params = new HttpParams();
    params = params.append("listGoodsId", listGoodsId);
    var res = await super.getCustomApi("GetDeliveryAndHubRouting", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as DeliveryAndhubRouting[];
    return data;
  }

  trackingShort(shipmentNumber: string, arrCols?: string[]) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    return super.getCustomApiPaging("trackingShort", arrCols, params);
  }

  async trackingShortAsync(
    shipmentNumber: string,
    arrCols: string[]
  ): Promise<Shipment> {
    const res = await this.trackingShort(shipmentNumber, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }

  async getShipmentByCodeAsync(shipmentNumber: string, arrCols: string[]) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    return super.getCustomApiPaging("getShipmentByCode", arrCols, params).toPromise();
  }

  async trackingShortNoMessageAsync(
    shipmentNumber: string,
    arrCols?: string[]
  ): Promise<Shipment> {
    const res = await this.trackingShort(shipmentNumber, arrCols).toPromise();
    if (!res.isSuccess) {
      return null;
    }
    const data = res.data as Shipment;
    return data;
  }

  getListShipmentPriceByPaymentId(paymentId: string, arrCols: string[]) {
    let params = new HttpParams();
    params = params.append("paymentid", paymentId);
    return super.getCustomApiPaging("GetListShipmentPriceByPaymentId", arrCols, params);
  }

  async getListShipmentPriceByPaymentIdAsync(paymentId: string, arrCols: string[]): Promise<Shipment[]> {
    const res = await this.getListShipmentPriceByPaymentId(paymentId, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getByShopCode(shopCode: string, customerId?: any, arrCols?: string[]) {
    let params = new HttpParams();
    params = params.append("shopCode", shopCode);
    params = params.append("customerId", customerId);
    return super.getCustomApiPaging("GetByShopCode", arrCols, params);
  }

  async getByShopCodeAsync(shopCode: string, customerId?: any, arrCols?: string[]): Promise<Shipment[]> {
    const res = await this.getByShopCode(shopCode, customerId, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  async getByShopCodeFirstAsync(shopCode: string, customerId?: any, arrCols?: string[]): Promise<Shipment[]> {
    let params = new HttpParams();
    params = params.append("shopCode", shopCode);
    params = params.append("customerId", customerId);
    const res = await super.getCustomApiPaging("GetByShopCodeFirst", arrCols, params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getListShipmentCODByPaymentId(paymentId: string, arrCols: string[]) {
    let params = new HttpParams();
    params = params.append("paymentid", paymentId);
    return super.getCustomApiPaging("GetListShipmentCODByPaymentId", arrCols, params);
  }

  async getListShipmentCODByPaymentIdAsync(paymentId: string, arrCols: string[]): Promise<Shipment[]> {
    const res = await this.getListShipmentCODByPaymentId(paymentId, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }


  transferLostPackage(model: Shipment) {
    return super.postCustomApi("TransferLostPackage", model);
  }


  async transferLostPackageAsync(model: Shipment): Promise<Shipment> {
    const res = await this.transferLostPackage(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }


  // assignShipmentWarehousing(model: AssignShipmentWarehousing) {
  //   return super.postCustomApi("AssignShipmentWarehousing", model);
  // }

  receiptWarehousing(model: AssignShipmentWarehousing) {
    return super.postCustomApi("ReceiptWarehousing", model);
  }

  async receiptWarehousingAsync(model: AssignShipmentWarehousing): Promise<any> {
    return this.receiptWarehousing(model).toPromise();
  }

  unLoadTransfer(model: AssignShipmentWarehousing) {
    return super.postCustomApi("UnLoadTransfer", model);
  }

  async unLoadTransferAsync(model: AssignShipmentWarehousing): Promise<any> {
    return this.unLoadTransfer(model).toPromise();
  }

  async unLoadTransferNewAsync(model: IssueTransferByProcModel): Promise<any> {
    return super.postCustomApi("UnLoadTransferNew", model).toPromise();
  }

  unLoadTransferLong(model: AssignShipmentWarehousing) {
    return super.postCustomApi("UnLoadTransferLong", model);
  }

  async unLoadTransferLongAsync(model: AssignShipmentWarehousing): Promise<any> {
    return this.unLoadTransferLong(model).toPromise();
  }

  async unLoadTransferLongNewAsync(model: AssignShipmentWarehousing[]): Promise<any> {
    return super.postCustomApi("UnLoadTransferLongNew", model).toPromise();
  }


  async receiptWarehousingDeliveryFail(model: AssignShipmentWarehousing[]): Promise<any> {
    return super.postCustomApi("ReceiptWarehousingDeliveryFail", model).toPromise();
  }

  issueTransfer(model: AssignShipmentWarehousing[]) {
    return super.postCustomApi("IssueTransfer", model);
  }

  async issueTransferByProcNew(model: IssueTransferByProcModel) {
    const res = await super.postCustomApi("IssueTransferByProc", model).toPromise();
    return res;
  }


  assignReturnList(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("assignReturnList", model);
  }

  async assignReturnListAsync(model: ListUpdateStatusViewModel): Promise<any> {
    const res = await this.assignReturnList(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListGoods;
    return data;
  }

  assignUpdateReturnList(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("assignUpdateReturnList", model);
  }

  assignTransferList(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("assignTransferList", model);
  }

  async assignTransferListAsync(model: ListUpdateStatusViewModel): Promise<ListGoods> {
    const res = await this.assignTransferList(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListGoods;
    return data;
  }

  assignUpdateTransferList(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("assignUpdateTransferList", model);
  }

  async assignUpdateTransferListAsync(model: ListUpdateStatusViewModel): Promise<ListGoods> {
    const res = await this.assignUpdateTransferList(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListGoods;
    return data;
  }

  hubConfirmMoneyFromRider(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("hubConfirmMoneyFromRider", model);
  }

  assignShipmentToTPL(model: AssignShipmentToTPL[]) {
    return super.postCustomApi("assignShipmentToTPL", model);
  }

  updateLadingSchedule(model: UpdateScheduleModel[]) {
    return super.postCustomApi("UpdateLadingSchedule", model);
  }

  updateStatusCurrentEmp(model: Shipment) {
    return super.postCustomApi("UpdateStatusCurrentEmp", model);
  }

  async assignStatusCurrentEmpAsync(model: Shipment): Promise<ListGoods> {
    const res = await this.updateStatusCurrentEmp(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListGoods;
    return data;
  }

  checkExistTPLNumber(tplNumber: string) {
    let params = new HttpParams();
    params = params.append("tplNumber", tplNumber);
    return super.getCustomApi("CheckExistTPLNumber", params);
  }

  async checkExistTPLNumberAsync(tplNumber: string): Promise<any> {
    const res = await this.checkExistTPLNumber(tplNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data as any;
  }

  getDeliveryHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi("getDeliveryHistory", params);
  }

  getByTPL(
    fromDate: any,
    toDate: any,
    arrCols: string[] = [],
    pageSize: number = undefined,
    pageNumber: number = undefined
  ) {
    let params = new HttpParams();
    if (fromDate)
      params = params.append(
        "fromDate",
        moment(fromDate).format("YYYY/MM/DD 00:00:00")
      );
    if (toDate)
      params = params.append(
        "toDate",
        moment(toDate).format("YYYY/MM/DD 23:59:59")
      );

    return super.getCustomApiPaging(
      "GetByTPL",
      arrCols,
      params,
      pageSize,
      pageNumber
    );
  }

  getReturnHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi("getReturnHistory", params);
  }

  getTransferHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi("getTransferHistory", params);
  }

  getHubConfirmMoneyFromRiderHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi("getHubConfirmMoneyFromRiderHistory", params);
  }

  getAccountantConfirmMoneyFromHubHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi(
      "getAccountantConfirmMoneyFromHubHistory",
      params
    );
  }

  getByStatusEmpId(
    empId: any,
    statusId: any,
    fromDate: Date,
    toDate: Date,
    arrCols: string[] = [],
    pageSize: number = undefined,
    pageNumber: number = undefined
  ) {
    let params = new HttpParams();
    params = params.append("empId", empId);
    params = params.append("statusId", statusId);
    if (fromDate)
      params = params.append(
        "fromDate",
        moment(fromDate).format("YYYY/MM/DD 00:00:00")
      );
    if (toDate)
      params = params.append(
        "toDate",
        moment(toDate).format("YYYY/MM/DD 23:59:59")
      );

    return super.getCustomApiPaging(
      "getByStatusEmpId",
      arrCols,
      params,
      pageSize,
      pageNumber
    );
  }

  getShipmentReportByEmpId(
    empId: any,
    fromDate?: Date,
    toDate?: Date,
    arrCols: string[] = [],
    pageSize: number = undefined,
    pageNumber: number = undefined
  ) {
    let params = new HttpParams();
    params = params.append("empId", empId);
    if (fromDate)
      params = params.append(
        "fromDate",
        moment(fromDate).format("YYYY/MM/DD 00:00:00")
      );
    if (toDate)
      params = params.append(
        "toDate",
        moment(toDate).format("YYYY/MM/DD 23:59:59")
      );

    return super.getCustomApiPaging(
      "getShipmentReportByEmpId",
      arrCols,
      params,
      pageSize,
      pageNumber
    );
  }

  async getShipmentReportByEmpIdAsync(empId: any,
    fromDate?: Date,
    toDate?: Date,
    arrCols: string[] = [],
    pageSize: number = undefined,
    pageNumber: number = undefined) {

    let res = await this.getShipmentReportByEmpId(empId, fromDate, toDate, arrCols, pageSize, pageNumber).toPromise();
    return res;
  }

  getAllHistory(fromDate: any, toDate: any) {
    let params = new HttpParams();

    params = params.append(
      "fromDate",
      moment(fromDate).format("YYYY/MM/DD 00:00:00")
    );
    params = params.append(
      "toDate",
      moment(toDate).format("YYYY/MM/DD 23:59:59")
    );

    return super.getCustomApi("getAllHistory", params);
  }

  checkExistTrackingNumber(trackingNumber: string): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("shipmentNumber", trackingNumber);
    return super.getCustomApi("CheckExistTrackingNumber", params);
  }

  async checkExistTrackingNumberAsync(trackingNumber: string): Promise<ResponseModel> {
    return await this.checkExistTrackingNumber(trackingNumber).toPromise();
  }

  getByStatusIds(ids: number[], arrCols: string[] = []): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = ids;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("getByStatusIds", obj);
  }

  async getByStatusIdsAsync(
    ids: number[],
    arrCols?: string[]
  ): Promise<Shipment[]> {
    const res = await this.getByStatusIds(ids, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getByListGoodsId(
    id: number,
    arrCols: string[] = [],
    isHideInPackage: boolean = false
  ): Observable<ResponseModel> {
    let obj = new IdModel();
    obj.id = id;
    obj.cols = arrCols.join(",");
    obj.isHideInPackage = isHideInPackage;
    return super.postCustomApi("getByListGoodsId", obj);
  }

  async getByListGoodsIdAsync(id: number, arrCols?: string[], isHideInPackage?: boolean): Promise<Shipment[]> {
    const res = await this.getByListGoodsId(id, arrCols, isHideInPackage).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  async getByListGoodsIdPagingAsync(viewModel: any): Promise<ResponseModel> {
    return await super.postCustomApi("getByListGoodsId", viewModel).toPromise();
  }

  getByListListGoodsId(
    ids: number[],
    arrCols: string[] = []
  ): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = ids;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("getByListListGoodsId", obj);
  }

  async getByListListGoodsIdAsync(ids: number[], arrCols?: string[]): Promise<Shipment[]> {
    const res = await this.getByListListGoodsId(ids, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getByListGoodsCode(
    code: string,
    arrCols?: string[]
  ): Observable<ResponseModel> {
    const obj = {
      code: code,
      cols: arrCols.join(",")
    }
    return super.postCustomApi("getByListGoodsCode", obj);
  }

  async getByListGoodsCodeAsync(code: string, arrCols?: string[]): Promise<Shipment[]> {
    const res = await this.getByListGoodsCode(code, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getByRequestShipmentId(id: any, cols: string[] = []): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("id", id);;
    return super.getCustomApiPaging("getByRequestShipmentId", cols, params);
  }

  async getByRequestShipmentIdAsync(id: any, cols?: string[]): Promise<Shipment[]> {
    const res = await this.getByRequestShipmentId(id, cols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  async createAsync(data: Shipment): Promise<any> {
    const res = await this.create(data).toPromise();
    if (!this.isValidResponse(res)) return;
    const shipment = res.data as Shipment;
    return shipment;
  }

  async updateAsync(data: Shipment): Promise<any> {
    const res = await this.update(data).toPromise();
    if (!this.isValidResponse(res)) return;
    const shipment = res.data as Shipment;
    return shipment;
  }

  updatePricePTNShipment(ShipmentId, FromDistrictId, FromProvinceId, TotalPrice, PricePTN): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("ShipmentId", ShipmentId);
    params = params.append("FromDistrictId", FromDistrictId);
    params = params.append("FromProvinceId", FromProvinceId);
    params = params.append("TotalPrice", TotalPrice);
    params = params.append("PricePTN", PricePTN);
    return super.getCustomApi("UploadPricePTNShipment", params);
  }

  acceptCreditTransfer(model) {
    return super.postCustomApi("AcceptCreditTransfer", model);
  }

  async acceptCreditTransferAsync(model): Promise<Shipment> {
    const res = await this.acceptCreditTransfer(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }

  cancel(model: UpdateViewModelShipment) {
    return super.postCustomApi("cancel", model);
  }

  async cancelAsync(model: UpdateViewModelShipment) {
    const res = await this.cancel(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }
  //================================//
  async trackingShortAsyncTransferReceive(
    shipmentNumber: string,
    arrCols: string[]
  ): Promise<Shipment> {
    const res = await this.trackingShort(shipmentNumber, arrCols).toPromise();
    const data = res.data as Shipment;
    return data;
  }

  getByShipmentNumber(shipmentNumber?: string, shipmentId?: any) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    params = params.append("shipmentId", shipmentId);
    return super.getCustomApi("getByShipmentNumber", params);
  }


  async getByShipmentNumberBoxWareHousing(model: Shipment) {
    const res = await super.postCustomApi("GetByShipmentNumberBoxWareHousing", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getByShipmentNumberS(shipmentNumberS: string, isEnabled: any = true, isSimilar: any = true, shipmentId?: any) {
    let params = new HttpParams();
    params = params.append("shipmentNumberS", shipmentNumberS);
    params = params.append("isEnabled", isEnabled);
    params = params.append("isSimilar", isSimilar);
    if (shipmentId)
      params = params.append("shipmentId", shipmentId);
    const res = await super.getCustomApi("GetByShipmentNumberS", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getByShipmentNumberAsync(shipmentNumber: string): Promise<ShipmentTracking> {
    const res = await this.getByShipmentNumber(shipmentNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ShipmentTracking;
    return data;
  }

  async getByShipmentNumberNewAsync(shipmentNumber: string, shipmentId: any = null, isEnabled: any = null): Promise<ShipmentTracking> {
    let params = new HttpParams();
    if (shipmentNumber)
      params = params.append("shipmentNumber", shipmentNumber);
    if (shipmentId)
      params = params.append("shipmentId", shipmentId);
    params = params.append("isEnabled", isEnabled);
    let res = await super.getCustomApi("GetByShipmentNumberNew", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ShipmentTracking;
    return data;
  }

  getShipmentEdit(shipmentNumber: string) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    return super.getCustomApi("GetShipmentEdit", params);
  }

  async getShipmentEditAsync(shipmentNumber: string): Promise<ShipmentTracking> {
    const res = await this.getShipmentEdit(shipmentNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ShipmentTracking;
    return data;
  }

  async getByShipmentNumberNoMessageAsync(shipmentNumber: string): Promise<ShipmentTracking> {
    const res = await this.getByShipmentNumber(shipmentNumber).toPromise();
    if (!res.isSuccess) return;
    const data = res.data as ShipmentTracking;
    return data;
  }

  getOnlyShipment(shipmentNumber: string, clos?: string[]) {
    let strCols = null;
    if (clos.length > 0) {
      strCols = clos.join(',');
    }
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    params = params.append("cols", strCols);
    return super.getCustomApi("GetOnlyShipment", params);
  }

  async getOnlyShipmentAsync(shipmentNumber: string, clos?: string[]): Promise<Shipment> {
    const res = await this.getOnlyShipment(shipmentNumber, clos).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }

  getGetLadingSchedule(shipmentId: number) {
    let params = new HttpParams();
    params = params.append("id", shipmentId + "");
    return super.getCustomApi("GetLadingSchedule", params);
  }

  async getGetLadingScheduleAsync(shipmentId: number): Promise<LadingSchesule[]> {
    const res = await this.getGetLadingSchedule(shipmentId).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as LadingSchesule[];
    return data;
  }

  //================================//

  cancelReturn(model: BaseModel) {
    return super.postCustomApi("CancelReturn", model);
  }

  async cancelReturnAsync(model: BaseModel): Promise<Shipment> {
    const res = await this.cancelReturn(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment;
    return data;
  }

  getByListId(shipmentIds: number[], cols?: string): Observable<ResponseModel> {
    const obj = new Object({
      "shipmentIds": shipmentIds,
      "cols": cols
    });
    return super.postCustomApi("getByListId", obj);
  }

  async updateStatusCurrentEmpAsync(model: any): Promise<ResponseModel> {
    return await super.postCustomApi("UpdateStatusCurrentEmp", model).toPromise();
  }

  async getByListIdAsync(shipmentIds: number[], cols?: string): Promise<Shipment[]> {
    const res = await this.getByListId(shipmentIds, cols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getAllPrintType() {
    let params = new HttpParams();
    return super.getCustomApi("getAllPrintType", params);
  }

  async getAllPrintTypeSelectItemAsync(): Promise<SelectItem[]> {
    const res = await this.getAllPrintType().toPromise();
    if (!this.isValidResponse(res)) return;
    let selectItem: SelectItem[] = [];
    const datas = res.data as any[];

    selectItem.push({ label: "Chọn tất cả", value: null });
    datas.forEach(element => {
      selectItem.push({
        label: element.name,
        value: element.id
      });
    });
    return selectItem;
  }

  printShipments(shipmentIds: number[], printTypeId: number): Observable<ResponseModel> {
    const obj = new Object({
      "shipmentIds": shipmentIds,
      "printTypeId": printTypeId
    });
    return super.postCustomApi("printShipments", obj);
  }

  async printShipmentsAsync(shipmentIds: number[], printTypeId: number): Promise<any> {
    const res = await this.printShipments(shipmentIds, printTypeId).toPromise();
    if (!res.isSuccess) return;
    return res;
  }


  getAllShipmentType() {
    let params = new HttpParams();
    return super.getCustomApi("getAllShipmentType", params);
  }

  async getAllShipmentTypeSelectItemAsync(): Promise<SelectItem[]> {
    const res = await this.getAllShipmentType().toPromise();
    if (!this.isValidResponse(res)) return;
    let selectItem: SelectItem[] = [];
    const datas = res.data as any[];

    datas.forEach(element => {
      selectItem.push({
        label: element.name,
        value: element.id
      });
    });
    return selectItem;
  }

  getCountByDeadLineType() {
    return super.getCustomApi("getCountByDeadLineType", null);
  }

  async getCountByDeadLineTypeAsync(): Promise<any> {
    const res = await this.getCountByDeadLineType().toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  updateDeliveryCompleteByIds(shipments: UpdateShipmentDeliveryComplete[]) {
    return super.postCustomApiPaging("updateDeliveryCompleteByIds", shipments);
  }

  async updateDeliveryCompleteByIdsAsync(shipments: UpdateShipmentDeliveryComplete[]): Promise<any> {
    const res = await this.updateDeliveryCompleteByIds(shipments).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  pickupCancel(model: any) {
    return super.postCustomApi("pickupCancel", model);
  }

  assignPickupList(model: ListUpdateStatusViewModel) {
    return super.postCustomApi("assignPickupList", model);
  }

  getReportSumaryByListIds(
    ids: number[],
    arrCols: string[] = []
  ): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = ids;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("getReportSumaryByListIds", obj);
  }

  async getReportSumaryByListIdsAsync(ids: number[], arrCols?: string[]): Promise<Shipment[]> {
    const res = await this.getReportSumaryByListIds(ids, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  getShipmentToPrint(ids: number[], arrCols: string[] = []): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = ids;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("GetShipmentToPrint", obj);
  }

  async printLongTermContract(id: any): Promise<any> {
    let params = new HttpParams();
    params = params.append("shipmentId", id);
    const res = await super.getCustomApi("PrintLongTermContract", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data as any;
  }

  async getShipmentToPrintAsync(ids: number[], arrCols: string[] = []): Promise<any> {
    const res = await this.getShipmentToPrint(ids, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as any;
    return data;
  }

  getBoxes(ids: number[], arrCols: string[] = []): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = ids;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("GetBoxes", obj);
  }

  async getBoxesAsync(ids: number[], arrCols: string[] = []): Promise<Boxes> {
    const res = await this.getBoxes(ids, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Boxes;
    return data;
  }
  //
  async getLastShipmentContractAsync(): Promise<LastShipmentContractModel> {
    let params = new HttpParams();
    const res = await super.getCustomApi("GetLastShipmentContract", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as LastShipmentContractModel;
    return data;
  }
  //
  async issueWarehousingAsync(viewModel: AssignShipmentWarehousing): Promise<ResponseModel> {
    let res = await super.postCustomApi("IssueTransfer", viewModel).toPromise();
    return res;
  }

  async assignDelivery(model: AssignDeliveryModel[]): Promise<ResponseModel> {
    let res = await super.postCustomApi("AssignDelivery", model).toPromise();
    this.isValidResponse(res);
    return res;
  }

  getListCompensationAsync(isCompleted: any, shipmentNumber?: any, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number, cols?: string[]): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("isCompleted", isCompleted);
    params = params.append("shipmentNumber", shipmentNumber);
    params = params.append("formDate", dateFrom);
    params = params.append("toDate", dateTo);
    return super.getCustomApiPaging("GetListCompensation", cols, params, pageSize, pageNumber).toPromise();
  }
  getCompensationType(): Promise<ResponseModel> {
    let params = new HttpParams();
    return super.getCustomApi("CompensationType", params).toPromise();
  }
  getFeeType(): Promise<ResponseModel> {
    let params = new HttpParams();
    return super.getCustomApi("GetFeeType", params).toPromise();
  }
  //handleCompensation
  async handleCompensationAsync(model: any): Promise<ResponseModel> {
    return await super.postCustomApi("HandleCompensation", model).toPromise();
  }
  async handleIncidents(model: HandleIncidents) {
    let res = await super.postCustomApi("HandleIncidents", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async addCompensation(model: AddCompensation) {
    let res = await super.postCustomApi("AddCompensation", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentDelayAsync(customerId: any, serviceId: any, reasonDelayId: any, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number, cols?: string[]): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("customerId", customerId);
    params = params.append("serviceId", serviceId);
    params = params.append("reasonDelayId", reasonDelayId);
    params = params.append("fromDate", dateFrom);
    params = params.append("toDate", dateTo);
    return await super.getCustomApiPaging("GetListShipmentDelay", cols, params, pageSize, pageNumber).toPromise();
  }

  async reCalcualteShipmentAsync(model: UpdateStatusCurrentEmp): Promise<ResponseModel> {
    return await super.postCustomApi("ReCalculateShipment", model).toPromise();
  }

  getByPackageId(
    id: number,
    arrCols: string[] = []
  ): Observable<ResponseModel> {
    let obj = new IdModel();
    obj.id = id;
    obj.cols = arrCols.join(",");
    return super.postCustomApi("getByPackageId", obj);
  }

  async getByPackageIdAsync(id: number, arrCols?: string[]): Promise<Shipment[]> {
    const res = await this.getByPackageId(id, arrCols).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }

  unAssign(obj: any): Observable<ResponseModel> {
    return super.postCustomApi("UnAssign", obj);
  }

  async unAssignAsync(obj: any): Promise<any> {
    const res = await this.unAssign(obj).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data;
    return data;
  }
  // ShipmentBox
  async getListShipmentBoxWarehouseByShipmentId(shipmentId: any, pageSize: any = null, pageNumber: any = null): Promise<Shipment[]> {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("pageSize", pageSize);
    params = params.append("pageNumber", pageNumber);
    let res = await super.getCustomApi("GetListShipmentBoxWarehouseByShipmentId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  getShipmentBoxByShipmentId(shipmentId: any, pageSize: any = null, pageNumber: any = null): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("pageSize", pageSize);
    params = params.append("pageNumber", pageNumber);
    params = params.append("cols", 'Structure,ShipmentStatus,CurrentHub,ListGoods.Truck,ListGoods,PickTruck,BoxType,EmpContact,EmpSendSMS');
    return super.getCustomApi("GetShipmentBoxByShipmentId", params).toPromise();
  }

  async getShipmentBoxByShipmentIdNew(shipmentId: any, isEnabled: any = true, pageSize: any = null, pageNumber: any = null) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("isEnabled", isEnabled);
    params = params.append("pageSize", pageSize);
    params = params.append("pageNumber", pageNumber);
    const res = await super.getCustomApi("GetShipmentBoxByShipmentIdNew", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getShipmentBoxByShipmentIdAsync(shipmentId: any, pageSize: any = null, pageNumber: any = null): Promise<Shipment[]> {
    const res = await this.getShipmentBoxByShipmentId(shipmentId, pageSize, pageNumber);
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  getShipmentBoxToPrint(id?: any, ids?: number[], shipmentId?: any): Promise<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = [];
    if (ids) obj.ids = ids;
    if (id) {
      obj.ids.push(id);
    }
    if (shipmentId) obj.shipmentId = shipmentId;
    return super.postCustomApi("GetShipmentBoxsToPrint", obj).toPromise();
  }

  getShipmentBoxToPrintBETA(id?: any, ids?: number[], shipmentId?: any): Promise<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = [];
    if (ids) obj.ids = ids;
    if (id) {
      obj.ids.push(id);
    }
    if (shipmentId) obj.shipmentId = shipmentId;
    return super.postCustomApi("GetShipmentBoxsToPrintBETA", obj).toPromise();
  }

  async getShipmentContractBoxsToPrint(shipmentId?: any): Promise<ResponseModel> {
    let param = new HttpParams();
    param = param.append("shipmentId", shipmentId);
    const res = await super.getCustomApi("GetShipmentContractBoxsToPrint", param).toPromise();
    if (res.isSuccess) return res.data;
    return;
  }

  getShipmentBoxToPrintBarcode(ids?: number[]): Promise<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = [];
    if (ids) obj.ids = ids;
    return super.postCustomApi("GetListShipmentBoxsPrintBarcode", obj).toPromise();
  }

  async getShipmentBoxToPrintAsync(id?: any, ids?: number[], shipmentId?: any): Promise<any[]> {
    let obj = new IdViewModel();
    obj.ids = [];
    if (ids) obj.ids = ids;
    if (id) {
      obj.ids.push(id);
    }
    if (shipmentId) obj.shipmentId = shipmentId;
    let res = await super.postCustomApi("GetShipmentBoxsToPrint", obj).toPromise();
    if (res.isSuccess) return res.data;
    return;
  }


  async getShipmentContractByShipmentId(shipmentId?: any, cols: any = "") {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("cols", cols);
    let res = await super.getCustomApi("GetShipmentContractByShipmentId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async createShipmentContract(model: Shipment) {
    let res = await super.postCustomApi("CreateShipmentContract", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async updateShipmentContract(model: Shipment) {
    let res = await super.postCustomApi("UpdateShipmentContract", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getShipmentContractToPrint(model: any) {
    let res = await super.postCustomApi("GetShipmentContractToPrint", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async checkInfoReceiveByPhoneNumberAsync(senderPhone: string, receiverPhone: string): Promise<ReceiverInfo[]> {
    let params = new HttpParams();
    params = params.append("senderPhone", senderPhone);
    params = params.append("receiverPhone", receiverPhone);
    let res = await super.getCustomApi("CheckInfoReceiveByPhoneNumber", params).toPromise();
    if (!res.isSuccess) return null;
    return res.data;
  }

  async CheckSenderInfoBySenderPhone(senderPhone: string, fromHubId: any, toHubId: any): Promise<SenderInfo[]> {
    let params = new HttpParams();
    params = params.append("senderPhone", senderPhone);
    params = params.append("fromHubId", fromHubId);
    params = params.append("toHubId", toHubId);
    const res = await super.getCustomApi("CheckSenderInfoBySenderPhone", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListPriceByShipmentIdToAhamove(model: any[]) {
    const res = await super.postCustomApi("GetListPriceByShipmentIdToAhamove", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async GetReportListShipmentExport(filterViewModel?: ShipmentFilterViewModel) {
    const res = await super.postCustomApiExcel("GetReportListShipmentExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  downLoadFile(data: any, type: string, fileName: string) {
    if (!fileName) fileName = "EXPORT_BAO_CAO";
    var a = document.createElement("a");
    document.body.appendChild(a);
    //
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    //
  }

  async GetListBoxCode(filterViewModel?: ListBoxCodeViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("getListBoxCode", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async GetListGoodTranferUnload(filterViewModel?: ListGoodTranferUnloadViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListGoodTranferUnload", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async GetListGoodsUnLoadTranferLong(filterViewModel?: ListGoodTranferUnloadViewModel): Promise<listGoodTranferUnload> {
    const res = await super.postCustomApi("GetListGoodsUnLoadTranferLong", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async GetListGoodsInLoad(filterViewModel?: ListGoodTranferUnloadViewModel): Promise<listGoodTranferUnload> {
    const res = await super.postCustomApi("GetListGoodsInLoad", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListUnloadInventory(filterViewModel?: GetListUnloadInventoryFilterViewModel): Promise<Shipment[]> {
    const res = await super.postCustomApi("GetListSaveWarehouse", filterViewModel).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Shipment[];
    return data;
  }


  receiptSaveWarehouse(model: AssignShipmentWarehousing) {
    return super.postCustomApi("ReceiptSaveWarehouse", model);
  }

  async receiptSaveWarehouseAsync(model: AssignShipmentWarehousing): Promise<any> {
    return this.receiptSaveWarehouse(model).toPromise();
  }

  listReceiptSaveWarehousingShipment(model: AssignShipmentWarehousing[]) {
    return super.postCustomApi("ListReceiptSaveWarehousingShipment", model);
  }

  async CheckValidSaveWarehouse(model: CheckValidSaveWarehouse) {
    return await super.postCustomApi("CheckValidSaveWarehouse", model).toPromise();
  }

  async listReceiptSaveWarehousingShipmentAsync(model: AssignShipmentWarehousing[]): Promise<any> {
    return this.listReceiptSaveWarehousingShipment(model).toPromise();
  }

  async GetListShipmentByListGoodId(listgoodId?: any, pageNumber?: any, pageSize?: any, toHubId?: any, shipmentNumberS?: any, senderName?: any, senderPhone?: any, receiverName?: any,
    receiverPhone?: any, groupId?: any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("id", listgoodId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    if (toHubId) params = params.append("toHubId", toHubId);
    if (shipmentNumberS) params = params.append("shipmentNumberS", shipmentNumberS);
    if (senderName) params = params.append("senderName", senderName);
    if (senderPhone) params = params.append("senderPhone", senderPhone);
    if (receiverName) params = params.append("receiverName", receiverName);
    if (receiverPhone) params = params.append("receiverPhone", receiverPhone);
    if (groupId) params = params.append("groupId", groupId);
    return super.getCustomApi("GetListShipmentByListGoodId", params).toPromise();
  }


  async getListShipmentUnloadByListGoodIdNew(listgoodId?: any, pageNumber?: any, pageSize?: any, toHubId?: any, shipmentNumberS?: any, senderName?: any, senderPhone?: any, receiverName?: any,
    receiverPhone?: any, listShipmentNumberSs: any[] = null, groupId?: any): Promise<ResponseModel> {

    let params = new HttpParams();
    params = params.append("id", listgoodId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    if (toHubId) params = params.append("toHubId", toHubId);
    if (shipmentNumberS) params = params.append("shipmentNumberS", shipmentNumberS);
    if (senderName) params = params.append("senderName", senderName);
    if (senderPhone) params = params.append("senderPhone", senderPhone);
    if (receiverName) params = params.append("receiverName", receiverName);
    if (receiverPhone) params = params.append("receiverPhone", receiverPhone);
    if (listShipmentNumberSs) {
      params = params.append("listShipmentNumberSs", listShipmentNumberSs.join(','));
    }
    if (groupId) params = params.append("groupId", groupId);
    return super.getCustomApi("GetListShipmentUnloadByListGoodIdNew", params).toPromise();
  }

  async getListShipmentUnloadByListGoodIdNewShipmentNumber(listgoodId?: any, pageNumber?: any, pageSize?: any, toHubId?: any, shipmentNumberS?: any, senderName?: any, senderPhone?: any, receiverName?: any,
    receiverPhone?: any,): Promise<ResponseModel> {

    let params = new HttpParams();
    params = params.append("id", listgoodId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    if (toHubId) params = params.append("toHubId", toHubId);
    if (shipmentNumberS) params = params.append("shipmentNumberS", shipmentNumberS);
    if (senderName) params = params.append("senderName", senderName);
    if (senderPhone) params = params.append("senderPhone", senderPhone);
    if (receiverName) params = params.append("receiverName", receiverName);
    if (receiverPhone) params = params.append("receiverPhone", receiverPhone);
    return super.getCustomApi("GetListShipmentUnloadByListGoodIdNew", params).toPromise();
  }


  async GetListShipmentNotTranfer(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentNotTranfer", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res
  }
  async getListShipmentToCustomer(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentToCustomer", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res
  }
  async scanShipmentToCustomer(shipmentNumber: any) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber + "");
    let res = await super.getCustomApi("ScanShipmentToCustomer", params).toPromise();
    return res
  }
  async getListDeliveryInfos(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListDeliveryInfos", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res
  }

  async GetShipmentUnLoadTranferLongByListGoods(listgoodId: any, pageNumber: any, pageSize: any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("id", listgoodId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    return super.getCustomApi("GetShipmentUnLoadTranferLongByListGoods", params).toPromise();
  }

  // async getShipmentByListGoodsId(listgoodId: any, pageNumber: any, pageSize: any): Promise<ResponseModel> {
  //   let params = new HttpParams();
  //   params = params.append("listGoodsId", listgoodId);
  //   params = params.append("pageNumber", pageNumber);
  //   params = params.append("pageSize", pageSize);
  //   return super.getCustomApi("GetShipmentByListGoodsId", params).toPromise();
  // }

  async GetListShipmentSaveWare(model: ShipmentFilterViewModel): Promise<Shipment[]> {
    let res = await super.postCustomApi("GetListShipmentSaveWare", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async GetListShipmentSaveWareNew(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentSaveWareNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async updateContactToShipmentNew(model: Shipment): Promise<any> {
    let res = await super.postCustomApi("UpdateContactToShipmentNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.isSuccess;
  }

  async updateContactToShipment(model: Shipment): Promise<ResponseModel> {
    let res = await super.postCustomApi("UpdateContactToShipment", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async sendSMS(model: Shipment): Promise<any> {
    let res = await super.postCustomApi("SendSMS", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.isSuccess;
  }

  async confirmCallCustomer(shipmentNumberS:any,shipmentId:any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append('shipmentNumberS',shipmentNumberS);
    params = params.append('shipmentId',shipmentId);
    let res = await super.postCustomApi("confirmCallCustomer", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async updateContactToShipmentOutWareHouse(model: Shipment): Promise<ResponseModel> {
    let res = await super.postCustomApi("UpdateContactToShipmentOutWareHouse", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentDeliveryPlaceAsync(model?: filterShipmentModel): Promise<Shipment[]> {
    let params = new HttpParams();
    if (model.compartmentId) params = params.append("compartmentId", model.compartmentId);
    if (model.shipmentNumberS) params = params.append("shipmentNumberS", model.shipmentNumberS);
    if (model.shipmentNumberW) params = params.append("shipmentNumberW", model.shipmentNumberW);
    if (model.toHubId) params = params.append("toHubId", model.toHubId);
    if (model.receiverName) params = params.append("receiverName", model.receiverName);
    if (model.receiverPhone) params = params.append("receiverPhone", model.receiverPhone);
    if (model.toDistrictId) params = params.append("toDistrictId", model.toDistrictId);
    if (model.toWardId) params = params.append("toWardId", model.toWardId);
    if (model.shippingAddress) params = params.append("streetName", model.shippingAddress);
    if (model.fromDate) params = params.append("fromDate", model.fromDate);
    if (model.toDate) params = params.append("toDate", model.toDate);
    params = params.append("typeShipmentBoxs", model.typeShipmentBoxs);
    if (model.deliveryVehicleTypeId) params = params.append("deliveryVehicleTypeId", model.deliveryVehicleTypeId);
    if (model.pageNumber) params = params.append("pageNumber", model.pageNumber);
    if (model.pageSize) params = params.append("pageSize", model.pageSize);
    let res = await super.getCustomApi("GetListShipmentDeliveryPlace", params).toPromise();
    if (!res.isSuccess) return null;
    return res.data;
  }

  async getListShipmentDeliveryPlaceNew(model?: ListShipmentDeliveryPlaceFilter): Promise<Shipment[]> {
    let res = await super.postCustomApi("GetListShipmentDeliveryPlaceNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async unloadShipmentInShipmentListGoods(model?: Shipment): Promise<ResponseModel> {
    let res = await super.postCustomApi("UnloadShipmentInShipmentListGoods", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async unloadShipmentInShipmentListGoodsNew(model?: AssignShipmentWarehousing[]): Promise<ResponseModel> {
    let res = await super.postCustomApi("UnloadShipmentInShipmentListGoodsNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async unloadShipmentInShipmentListGoodsNew2(model?: IssueTransferByProcModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("UnloadShipmentInShipmentListGoodsNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async cancelSaveWarehousingShipment(model?: AssignShipmentWarehousing[]): Promise<ResponseModel> {
    let res = await super.postCustomApi("CancelSaveWarehousingShipment", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListPriceByShipmentIdAsync(shipmentId: any, listShipmentId: any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("listShipmentId", listShipmentId);

    let res = await super.getCustomApi("GetListPriceByShipmentId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListPriceByShipmentIdNew(shipmentId: any, listShipmentId: string = "", showAllPrice: any, isPaid: any = null, promotionId: any = null): Promise<ListPriceByShipmentId[]> {
    let params = new HttpParams();
    params = params.append("ShipmentId", shipmentId);
    params = params.append("ListShipmentId", listShipmentId);
    params = params.append("promotionCode", promotionId);
    if (showAllPrice) {
      params = params.append("ShowAllPrice", showAllPrice);
    }
    if (isPaid != null) {
      params = params.append("isPaid", isPaid);
    }
    let res = await super.getCustomApi("GetListPriceByShipmentIdNew", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }


  async updateShipmentInfo(model?: Shipment): Promise<ResponseModel> {
    let res = await super.postCustomApi("UpdateShipmentInfoNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  async updateShipmentInfoAsync(data: Shipment): Promise<any> {
    const res = await this.updateShipmentInfo(data);
    if (!this.isValidResponse(res)) return;
    const shipment = res.data as Shipment;
    return shipment;
  }

  getAllShipmentInDay(createdWhen: any, listShipmentIds: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("createdWhen", createdWhen);
    params = params.append("listShipmentIds", listShipmentIds);

    let res = super.getCustomApi("GetAllShipmentInDay", params);
    return res;
  }

  getAllLoInDay(createdWhen: any, listShipmentIds: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("createdWhen", createdWhen);
    params = params.append("listShipmentIds", listShipmentIds);

    let res = super.getCustomApi("GetAllLoInDay", params);
    return res;
  }

  async getShipmentFirst(fromHubId: any, senderPhone: any, receiverPhone: any, isSenderPhone: any): Promise<Shipment> {
    let paramas = new HttpParams();
    paramas = paramas.append("fromHubId", fromHubId);
    paramas = paramas.append("senderPhone", senderPhone);
    paramas = paramas.append("receiverPhone", receiverPhone);
    paramas = paramas.append("isSenderPhone", isSenderPhone);
    let res = await super.getCustomApi("GetShipmentFirst", paramas).toPromise();
    if (!res.isSuccess) return null;
    return res.data;
  }

  async checkPromotionCode(model: any): Promise<any> {
    // let paramas = new HttpParams();
    // paramas = paramas.append("promotionCode", promotionCode);
    // paramas = paramas.append("customerId", customerId);
    // paramas = paramas.append("isPlus", isPlus);
    const res = await super.postCustomApi("CheckPromotionCode", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListPromotionCodeByCustomerId(customerId: any): Promise<any> {
    let paramas = new HttpParams();
    paramas = paramas.append("customerId", customerId);
    const res = await super.getCustomApi("GetListPromotionCodeByCustomerId", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentNumberSTransferLong(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentNumberSTransferLong", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  async getListShipmentNumberSTransfer(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentNumberSTransfer", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipmentNumberSWareHousing(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    let res = await super.postCustomApi("GetListShipmentNumberSWareHousing", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getListShipmentByListGoodIdOutWareHouse(listGoodId: any, pageNumber: any, pageSize: any): Promise<Shipment[]> {
    let paramas = new HttpParams();
    paramas = paramas.append('listGoodId', listGoodId);
    paramas = paramas.append('pageNumber', pageNumber);
    paramas = paramas.append('pageSize', pageSize);
    const res = await super.getCustomApi("GetListShipmentByListGoodIdOutWareHouse", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getlistShipmentBoxByListGoodIdAndShipmentId(listGoodId: any, shipmentId: any): Promise<Shipment[]> {
    let paramas = new HttpParams();
    paramas = paramas.append('listGoodId', listGoodId);
    paramas = paramas.append('shipmentId', shipmentId);
    const res = await super.getCustomApi("GetlistShipmentBoxByListGoodIdAndShipmentId", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getlistShipmentNumberFilter(textSearchShipmentNumber: any, shipmentType: any): Promise<any[]> {
    let paramas = new HttpParams();
    if (textSearchShipmentNumber)
      paramas = paramas.append("textSearchShipmentNumber", textSearchShipmentNumber);
    if (shipmentType)
      paramas = paramas.append("shipmentType", shipmentType);
    const res = await super.getCustomApi("GetlistShipmentNumberFilter", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async checkShipmentStatusInListGoods(listGoodId: any, shipmentStatusId: any) {
    let paramas = new HttpParams();
    paramas = paramas.append("listgoodId", listGoodId);
    paramas = paramas.append("shipmentStatusId", shipmentStatusId);
    const res = await super.getCustomApi("CheckShipmentStatusInListGoods", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async updateShipmentStatus(model: Shipment) {
    const res = await super.postCustomApi("UpdateShipmentStatus", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentByShipmentContactId(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApi("GetListShipmentByShipmentContactId", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentReceipMoney(empId: any, fromDate: any, toDate: any, pageNumbe: any, pagesize: any) {
    let param = new HttpParams();
    param = param.append('empId', empId);
    param = param.append('fromDate', fromDate);
    param = param.append('toDate', toDate);
    param = param.append('pageNumber', pageNumbe);
    param = param.append('pageSize', pagesize);
    const res = await super.getCustomApi("GetListShipmentReceipMoney", param).toPromise();
    if (!this.isValidResponse(res)) return
    return res.data;
  }

  async getReportDeliveryEmployeeDetail(model: ReportDeliveryEmployee): Promise<Shipment[]> {
    const res = await super.postCustomApi("getReportDeliveryEmployeeDetail", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentPaymentShortDebit(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApi("GetListShipmentPaymentShortDebit", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentPaymentLongDebit(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApi("GetListShipmentPaymentLongDebit", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentReceiptMoneyDebit(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApi("GetListShipmentReceiptMoneyDebit", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async GetListShipmentDelivery(deliveryInfoId: any, pageNumber: any, pageSize: any) {
    let paramas = new HttpParams();
    if (deliveryInfoId)
      paramas = paramas.append("deliveryInfoId", deliveryInfoId);
    if (pageNumber)
      paramas = paramas.append("pageNumber", pageNumber);
    if (pageSize)
      paramas = paramas.append("pageSize", pageSize);
    const res = await this.getCustomApi("GetListShipmentDelivery", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentIdsByDeliveryInfo(deliveryInfoId: any) {
    let paramas = new HttpParams();
    if (deliveryInfoId)
      paramas = paramas.append("deliveryInfoId", deliveryInfoId);
    const res = await this.getCustomApi("GetListShipmentIdsByDeliveryInfo", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentBoxsWareHouse(model: WareHouseFilterModel) {
    const res = await this.postCustomApi("GetListShipmentBoxsWareHouse", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListShipmentWaitUnloading(fromDate: any, toDate: any, pageNumber: any, pageSize: any) {
    let paramas = new HttpParams();
    paramas = paramas.append("fromDate", fromDate);
    paramas = paramas.append("toDate", toDate);
    paramas = paramas.append("pageNumber", pageNumber);
    paramas = paramas.append("pageSize", pageSize);
    const res = await this.getCustomApi("GetListShipmentWaitUnloading", paramas).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async printQrCodeVnPay(model: PrintQrCodeVnPayModel) {
    const res = await this.postCustomApi("PrintQrCodeVnPay", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async generateQRForNewShipment(shipmentId: number): Promise<QrPaymentShipmentModel> {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId + "");
    const res = await this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/GenerateQRForNewShipment`, null, { params }).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async generateQRForDelivery(deliveryInfoId: number): Promise<QrPaymentShipmentModel> {
    let params = new HttpParams();
    params = params.append("deliveryInfoId", deliveryInfoId + "");
    const res = await this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/GenerateQRForDelivery`, null, { params }).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListTransactionHistoryByShipmentId(id: any) {
    let params = new HttpParams();
    params = params.append("shipmentId", id);
    const res = await this.getCustomApi("GetListTransactionHistoryByShipmentId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async updateStatusShipment(model: ShipmentFilterViewModel) {
    const res = await this.postCustomApi("UpdateStatusShipment", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

}